import { mergeDeep } from '@/helpers/utils'
import { pickStickyVariant } from '@/modules/Landing/helpers/stickyVariant'
import { LandingComponentsConfig, LandingScreenSchema } from '@/modules/Landing/instances/@types/landing-types'

type AbSmartly = { variantConfig: (experimentName: string) => Record<string, unknown> }

const EXPERIMENT_NAME = 'web_fasting_f_welcome_topic'

export default (schemas: LandingScreenSchema[], $absmartly?: AbSmartly): LandingScreenSchema[] => {
	const config = $absmartly?.variantConfig?.(EXPERIMENT_NAME)
	const variant = pickStickyVariant({ variants: config?.variants, cacheKey: EXPERIMENT_NAME })

	const extensionSchema: Partial<LandingScreenSchema>[] = [
		{
			components: {
				LandingTitle: ({ $t }): LandingComponentsConfig['LandingTitle'] => ({
					title: variant?.title ?? $t('pages.landing.male_funnel.title'),
					size: 'small',
				}),
			},
			config: {
				analytics: { screenId: variant?.id ?? 'unknown' },
			},
		},
	]

	return mergeDeep([...schemas], extensionSchema)
}
